export const genreOptions = [
  { label: '全部体裁', value: 'all' },
  { label: '都市', value: '都市' },
  { label: '职场', value: '职场' },
  { label: '爱情', value: '爱情' },
  { label: '悬疑', value: '悬疑' },
  { label: '犯罪', value: '犯罪' },
  { label: '古装', value: '古装' },
  { label: '武侠', value: '武侠' },
  { label: '家庭', value: '家庭' },
  { label: '年代', value: '年代' },
  { label: '医疗', value: '医疗' },
  { label: '青春', value: '青春' },
  { label: '科幻', value: '科幻' },
  { label: '剧情', value: '剧情' },
];

export const regionOptions = [
  { label: '全部地区', value: 'all' },
  { label: '中国大陆', value: '中国大陆' },
  { label: '中国香港', value: '中国香港' },
];

export const yearOptions = [
  { label: '全部年份', value: 'all' },
  { label: '2025', value: '2025' },
  { label: '2024', value: '2024' },
  { label: '2023', value: '2023' },
];

export const sortOptions = [
  { label: '按更新时间', value: 'update' },
  { label: '按热度', value: 'heat' },
  { label: '按评分', value: 'rating' },
];

export const newsCategoryOptions = [
  { label: '全部资讯', value: 'all' },
  { label: '行业动态', value: '行业动态' },
  { label: '明星资讯', value: '明星资讯' },
  { label: '剧透解析', value: '剧透解析' },
  { label: '影视评论', value: '影视评论' },
  { label: '幕后花絮', value: '幕后花絮' },
];